<template>
  <div
    class="fd-table fd-table-skeleton well-table sample-table"
    :class="{ 'fd-table-skeleton--user': rowVariant === 'user' }"
    :style="{ '--fd-table-skeleton-cols': columns }"
  >
    <div v-if="showHeader" class="fd-table-skeleton-row fd-table-skeleton-row--head">
      <span v-for="n in columns" :key="'h-' + n" class="fd-table-skeleton-cell" />
    </div>
    <div v-for="r in rows" :key="'r-' + r" class="fd-table-skeleton-row">
      <span v-for="n in columns" :key="'c-' + r + '-' + n" class="fd-table-skeleton-cell" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TabularLoaders",
  props: {
    columns: {
      type: Number,
      default: 6,
    },
    rows: {
      type: Number,
      default: 8,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    rowVariant: {
      type: String,
      default: "table",
    },
  },
};
</script>
